import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "share-asin-container"
};
var _hoisted_2 = {
  class: "row-1 mb32"
};
var _hoisted_3 = {
  class: "row-2"
};
import { useLess } from '@/models/hooks';
import { useStore } from 'vuex';
export default {
  __name: 'ShareAsinImg3',
  setup(__props) {
    useLess('components/shareApp/components/shareAsin.less');
    var store = useStore();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(store).state.share.picListSelected[0]})`
        })
      }, null, 4)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(store).state.share.picListSelected[1]})`
        })
      }, null, 4), _createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(store).state.share.picListSelected[2]})`
        })
      }, null, 4)])]);
    };
  }
};